<template>
    <router-view  />
    <GlobalLoader />
</template>

<script>
import GlobalLoader from "@/components/GlobalLoader.vue";

import { ref, provide } from "vue";

const globalFlag_full_amounts = ref(false);
provide("globalFlag_full_amounts", globalFlag_full_amounts);

// import LoginOne from "@/components/Login.vue";
/* eslint-disable */
    export default {
        name: "App",
        // com/3/6ponents: { LoginOne },
    };
</script>
